import { cn } from '~/utils/cn'

export default function SpinnerCircle({
  color = '#2464F6',
  className,
}: {
  color?: string
  className?: string
}) {
  return (
    <div role="status" className="inline-flex items-center justify-center">
      <svg
        className={cn('w-5 h-5 animate-spin', className)}
        style={{ 
          width: '1.25rem', 
          height: '1.25rem', 
          minWidth: '1.25rem', 
          minHeight: '1.25rem', 
          maxWidth: '1.25rem', 
          maxHeight: '1.25rem',
          flexShrink: 0
        }}
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <circle
          cx="10.5"
          cy="11"
          r="8.75"
          stroke={color}
          strokeOpacity="0.25"
          strokeWidth="3"
        />
        <path
          d="M19.25 11C19.25 6.16751 15.3325 2.25 10.5 2.25"
          stroke={color}
          strokeWidth="3"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>
  )
}
